import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetLeaveRuleForViewDto, GetLeaveTypesForViewDto, LeaveTypesDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewLeaveTypesModal',
    templateUrl: './view-leaveTypes-modal.component.html'
})
export class ViewLeaveTypesModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetLeaveRuleForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetLeaveRuleForViewDto();
        //this.item.leaveTypes = new LeaveTypesDto();
    }

    show(item: GetLeaveRuleForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
